var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    ( _obj = {}, _obj['isActive'] = _vm.isActive(), _obj ),
    "w-8 h-8 text-gray-800 rounded fill-current items-center p-2" ],attrs:{"title":_vm.title},on:{"click":_vm.action}},[_c('svg',{staticClass:"remix h-full w-full"},[_c('use',{attrs:{"xlink:href":(_vm.remixiconUrl + "#ri-" + _vm.icon)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }